<template>
  <div class="antialiased">

    <Sidebar/>


    <div class="page">

      <Header hint="Cari" :enabled="false"/>

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">
                  Laporan Total Sales
                </h2>
              </div>

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto px-0">

                  </div>

                  <div class="col-auto">
                    <button class="btn btn-white" v-html="ic('filter')+' Filter'" @click="_filter"> </button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>

          <Nodata v-if="!loading && data.length == 0 && isFilter"/>
          <div class="alert alert-info" v-if="!isFilter && !loading">
            <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat data Total Sales
          </div>

          <div class="text-center my-6" v-if="!loading && data.length > 0">

            <img :src="asset('doc.png')" alt="" style="width: 200px; opacity: .5">
            <h3 class="my-3" v-html="'Berhasil Mendapatkan Data'"></h3>

            <div class="btn-group">
              <button class="btn btn-outline-primary" @click="_createPdf">Export PDF</button>
              <button class="btn btn-primary" @click="_createExcel()">Export Excel</button>
            </div>

          </div>

        </div>
      </div>

    </div>

    <FormFilter
      :config.sync="filter.config"
      :initData="filter.data" :dismiss.sync="filter.dismiss"
      :isSubmit.sync="filter.isSubmit"
      @submit="filter.action"
    />

  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue"

import jsPDF from "jspdf";
import "jspdf-autotable";
import XLSX from 'xlsx';

export default {
  name: "LaporanSales",
  components: { FormFilter },

  data() {
    return {
      auth: {},

      filter: {
        config: { view: false, title: null },
        data: null, isSubmit: false,
        action: () => {}
      },

      loading: false, isFilter: false,
      data: [],
      total: {},
      year: "",

      dataFilter: {
        start_date: this.dateTime('ymd'),
        end_date: this.dateTime('ymd'),
      },
    };
  },

  mixins: [helper],

  methods: {

      _get(){
        this.loading = true

        this.axios.get("report/total/sales",{params: this.dataFilter}).then(res => {
          this.loading = false;

          this.data = []

          if(res.data.length != 0){
            this.data = res.data.data
            this.total = res.data.total
          }

          this.year = (this.dataFilter.end_date.split("-"))[0];
        }).catch( err => {
          this.loading = false
          this.onError(err)
        });
      },

      _filter(){
        this.filter.config = {view: true, title: 'Filter'}
        this.filter.action = (formData) => {
          this.isFilter = true
          
          for (const key in formData) {
            this.dataFilter[key] = formData[key]
          }

          this._get()
        }
      },

      _createPdf(){
        let doc = new jsPDF('p'), user = JSON.parse(localStorage.user);
        let styles = { fillColor: [255, 255, 255], cellPadding: 0, lineColor: 0 }

        // title
        doc.autoTable({
          theme: 'plain',
          styles: { fillColor: [255, 255, 255], cellPadding: 0, lineColor: 0 },
          margin: { top: 10, left: 10, right: 10 },
          columnStyles: { 1: { halign: 'center', fontSize: 18 } },

          head: [['Laporan Sales ALL', '']],

          body: [
            ['Laporan Sales ALL ' + this.year + ' (penjualan total ' + this.year + ' per hari pelaporan)', { content: "Laporan Sales ALL " + this.year, rowSpan: 2, styles: { halign: 'right' } }],
            ['',],
            ['Total Sales - Lumbung Group ' + this.year,],
            ['Data Received ' + this.dataFilter.start_date + ' until ' + this.dataFilter.end_date,],
          ],
        })

        let header = [['Distributor', 'Volume', 'In Value']], temp = [];

        for(let i = 0; i < this.data.length; i++){
          let data = this.data[i];
          temp.push(data.distributor);
          temp.push(this.ribuan(Math.round(data.volume)));
          temp.push(this.ribuan(Math.round(data.in_value)));

          header.push(temp);
          temp = [];
        }
        header.push(['Grand Total', this.ribuan(Math.round(this.total.volume)), this.ribuan(Math.round(this.total.in_value))])

        styles['cellPadding'] = 2;

        doc.autoTable({ // body
          theme: 'grid', styles: styles, margin: { top: 10, left: 10, right: 10 },
          body: header,
        })

        this.pdfDownload([ doc.output() ])
      },

      _createExcel(){
        return this._createExcelDefault()
      },

      _createExcelDefault(){
        // this.createExcel({data: dataExcel, filename: 'laporan-stt-'+this.dataFilter.start_date+' - '+this.dataFilter.end_date}, false)
        const workbook = XLSX.utils.book_new();

        const worksheet = XLSX.utils.json_to_sheet([]);

        const content = [];
        content.push(['Laporan Sales ALL ' + this.year + ' (penjualan total ' + this.year + ' per hari pelaporan)', '', '']);
        content.push(['', '', '']);
        content.push(['Total Sales - Lumbung Group ' + this.year, '', '']);
        content.push(['Data Received ' + this.dataFilter.start_date + ' until ' + this.dataFilter.end_date, '', '']);
        content.push(['', '', '']);

        const headers = ['Distributor', 'Volume', 'In Value'];
        content.push(headers)

        for(let i = 0; i < this.data.length; i++){
          let data = this.data[i];
          content.push([data.distributor, data.volume, data.in_value])
        }
        content.push(['Grand Total', this.total.volume, this.total.in_value])

        XLSX.utils.sheet_add_aoa(worksheet, content);
        
        const merge = [
          {
            s: { r: 0, c: 0 },
            e: { r: 0, c: 1 }
          },
          {
            s: { r: 2, c: 0 },
            e: { r: 2, c: 1 }
          },
          {
            s: { r: 3, c: 0 },
            e: { r: 3, c: 1 }
          }
        ]

        worksheet['!merges'] = merge;

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Total Sales');

        XLSX.writeFile(workbook, 'laporan_total_sales_' + this.dataFilter.start_date + '_sampai_' + this.dataFilter.end_date + '.xlsx');
      }
  },

  mounted(){
    this.auth = JSON.parse(localStorage.user)
    // this._get()
  },

};
</script>
